// extracted by mini-css-extract-plugin
module.exports = {"formRow":"PoliticalCheckout_formRow__26S0m","agreementDetail":"PoliticalCheckout_agreementDetail__1OZjm","fldSelect":"PoliticalCheckout_fldSelect__2IWo8"};